"use client"

import PropTypes from "prop-types"
import { RiDownloadCloud2Line } from "react-icons/ri"

import theme from "@/theme"

import { Button } from "./Button"

/**
 * This component renders a button with icon and optional text for downloading files
 *
 * @param {object} props
 * @param {string} props.number - The document number to download
 * @param {boolean} props.large - If true, the icon will be larger
 * @param {string} props.text - The text to display on the button
 * @param {node} props.children - Optional icon to display inside the button
 * @returns {JSX.Element}
 */
export const DownloadButton = ({ number, large = false, text, children, ...props }) => {
  const { small, xtraLarge } = theme.iconSizes

  const handleDownload = (number) => {
    const link = document.createElement("a")
    link.href = `/api/file/${number}`
    link.setAttribute("download", `${number}.pdf`)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  return (
    <Button onClick={() => handleDownload(number)} {...props}>
      {children ?? <RiDownloadCloud2Line size={large ? xtraLarge : small} />}
      <span>{text}</span>
    </Button>
  )
}

DownloadButton.propTypes = {
  /** Defines the document number to download */
  number: PropTypes.string.isRequired,
  /** Defines whether the icon should be large */
  large: PropTypes.bool,
  /** Defines the text of the button */
  text: PropTypes.string,
  /** Defines the icon of the button */
  children: PropTypes.node,
}
